module.exports = require('./isBase64')
